import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import useField from '../hooks/use-field'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

function Editor (props) {
  const field = useField(props)

  const quillModules = {
    toolbar: props.toolbar
      ? props.toolbar
      : [
          ['bold', 'italic', 'underline', 'strike'], // toggled buttons
          ['blockquote', 'code-block'],

          [{ header: 1 }, { header: 2 }], // custom button values
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
          [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
          [{ direction: 'rtl' }], // text direction

          [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ['link', 'image', 'video'],
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],

          ['clean'] // remove formatting button
        ]
  }

  return field.wrap(() => (
    <>
      <input type='hidden' name={field.name} defaultValue={field.value} />
      <div spellCheck='false'>
        <ReactQuill
          value={field.value} onChange={field.onChange} modules={quillModules}
          placeholder={props.placeholder}
        />
      </div>
    </>
  ))
}

Editor.defaultProps = {
  ...useField.defaultProps,
  placeholder: ''
}

Editor.propTypes = {
  ...useField.propTypes,
  toolbar: PropTypes.array,
  placeholder: PropTypes.string
}

export default observer(Editor)
